import React from 'react';
import PropTypes from 'prop-types';

import l from '../../libs/localization';

import Card from '../Card';
import Form from '../Form';
import MultiSelect from '../MultiSelect';

const CompressorListFilter = ({
  filters,
  onFilter,
  filterData,
  rightButtons,
}) => {
  return (
    <Form onSubmit={onFilter} initialValue={filters}>
      {({ controlInput }) => (
        <div className="flex">
          <div className="filters">
            <div className="input-group">
              <span className="input-group-addon">
                <span className="glyphicon glyphicon-search" />
              </span>
              <input
                type="text"
                className="form-control"
                placeholder={l('COMPRESSOR.SEARCH_PLACEHOLDER')}
                {...controlInput('search')}
              />
            </div>
          </div>
          <div className="button-container">
            <button type="submit" className="btn btn-secondary">
              <span className="glyphicon glyphicon-filter" />
              <b className="margin-left-10">{l('COMMON.SEARCH')}</b>
            </button>

            {rightButtons && <div className="pull-right">{rightButtons}</div>}
          </div>
          <div className="button-container">
            {rightButtons && <div className="pull-right">{rightButtons}</div>}
          </div>
        </div>
      )}
    </Form>
  );
};

CompressorListFilter.propTypes = {
  rightButtons: PropTypes.node,
};

CompressorListFilter.defaultProps = {
  rightButtons: null,
};

export default CompressorListFilter;
